import {AddSchema, GetDoc, GetDocs, CreateAccessor} from "mobx-graphlink";
import {StoryMessage} from "./storyMessages/@StoryMessage.js";

export const GetStoryMessage = CreateAccessor((id: string|n): StoryMessage|n=>{
	return GetDoc({}, a=>a.storyMessages.get(id!));
});
export const GetStoryMessages = CreateAccessor((userId: string, storyId: string, parentId?: string, orderByCreatedAt = true): StoryMessage[]=>{
	let result = GetDocs({
		params: {filter: {
			creator: userId != null && {equalTo: userId},
			story: {equalTo: storyId},
			parent: parentId && {equalTo: parentId},
		}}
	}, a=>a.storyMessages);
	if (orderByCreatedAt) result = result.OrderBy(a=>a.createdAt);
	return result;
});

/** Returned message-chain is in chronological order. (well more precisely, index 0 holds the "furthest-back ancestor" in the parent chain) */
export function FindMessagesInChain(messages: StoryMessage[], finalMessageInChain: StoryMessage, allowSummaries = true, terminateAtMessageX = null as ((msg: StoryMessage)=>boolean)|n, mustFindTerminateMessage = true) {
	const chain = [finalMessageInChain];
	let currentMessage = finalMessageInChain;
	while (currentMessage.parent && !terminateAtMessageX?.(currentMessage)) {
		const parentMessage_summaryIntercept = allowSummaries && currentMessage.parent != null
			// use findLast, so that if two summaries exist for the same chain-end, we prefer the newer one
			? messages.findLast(a=>a.summary_chainEnd == currentMessage.parent && a.summary_enabled)
			: null;
		const parentMessage_normal = messages.find(a=>a.id == currentMessage.parent);
		const parentMessage = parentMessage_summaryIntercept ?? parentMessage_normal;
		if (parentMessage == null) break;

		chain.Insert(0, parentMessage);
		currentMessage = parentMessage;
	}
	if (terminateAtMessageX != null && mustFindTerminateMessage && !terminateAtMessageX(chain[0])) {
		throw new Error("Terminate-at message not found in chain.");
	}
	return chain;

}